import { v4 as uuidv4 } from 'uuid';

/**
 * provides an implementation of _generateAndGetHardwareId that returns a random
 * UUID
 *
 * @mixin RandomUuidHardwareIdGeneratorMixin
 */
var RandomUuidHardwareIdGeneratorMixin = function () {
    /**
     * returns a resolved promise which returns a random UUID
     *
     * @method _generateAndGetHardwareId
     * @return {Promise<string>}
     * @memberOf RandomUuidHardwareIdGeneratorMixin
     */
    this._generateAndGetHardwareId = function () {
        return Promise.resolve('Random://' + uuidv4());
    };
};

export { RandomUuidHardwareIdGeneratorMixin };
